import React from 'react'
import { useTranslation } from 'next-i18next'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { CustomTextInput } from 'src/components'
import { projectFormIsActiveSelector, setProjectFormItemValue } from 'src/features'

const ProjectCertificationCentralName: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const isActive = useAppSelector(projectFormIsActiveSelector)

  return <CustomTextInput
    name='central_name'
    placeholder={t('Projects.Form.CentralPlaceholder')}
    onChange={(e) => dispatch(setProjectFormItemValue({ key: 'central_name', value: e.target.value }))}
    required={isActive}
  />
}

export default ProjectCertificationCentralName
